import { Grid, makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { newsSelector, resourceVisitsSelector } from "../redux/selectors";
import { NewsAppBar } from "./NewsAppBar";
import { Pager } from "@ofqual/portal-components/components/Pager";
import { useSearch, useUrl } from "@ofqual/portal-core/core/hooks";
import { loadingNews, loadingResourceVisits } from "../redux/actions";
import { NewsList } from "./NewsList";
import { HistoryList } from "./HistoryList";
import { FilterControls } from "./FilterControls";
import { Survey } from "./Survey";
import { useAuth } from "@ofqual/portal-core/core/hooks/";
import { authSelector } from "../redux/selectors";
import { ExperimentalFeature } from "@ofqual/portal-components/components/ExperimentalFeature";


const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginTop: theme.contentOffsets.AFTER_SECONDARY_APPBAR,
    },
    sectionHeading: {
      textTransform: "uppercase",
      color: theme.palette.grey[500],
      marginBlockStart: 10, // try to acheive same padding/positioning as pager
    },
  };
});

export const News: React.FC = () => {
  const classes = useStyles();
  const news = useSelector(newsSelector);
  const resourceVisits = useSelector(resourceVisitsSelector);
  const dispatch = useDispatch();

  const { searchParams, navigateToNextPage } = useSearch(useUrl());
  const { experimentalFeatures } = useAuth(authSelector);

  useEffect(() => {
    dispatch(loadingNews(searchParams));
  }, [dispatch, searchParams]);

  useEffect(() => {
    dispatch(loadingResourceVisits());
  }, [dispatch]);

  return (
    <div className={classes.root}>

      <NewsAppBar>
        <FilterControls />
      </NewsAppBar>
      <Grid container spacing={3}>
        <Grid item md={8}>
          <ExperimentalFeature
            experimentalModuleName="portal-home"
            experimentalFeatures={experimentalFeatures}
            experimentalFeatureVisibleName="portal-home-survey">
            <Survey />
          </ExperimentalFeature>
          <Grid container justify="space-between">
            <Grid item>
              <h3 className={classes.sectionHeading}>Latest News</h3>
            </Grid>
            <Grid item>
              <Pager
                state={news}
                navigateToNextPage={navigateToNextPage}
                showRecordCount={false}
                showRowsPerPage={false}
                pageLabel="Page"
                showFirstLastButtons={false}
              />
            </Grid>
          </Grid>

          <NewsList newsState={news} />
        </Grid>
        <Grid item md={4} xs={12}>
          <h3 className={classes.sectionHeading}>Recently Viewed</h3>
          <HistoryList resourceVisitsState={resourceVisits} />
        </Grid>
      </Grid>
    </div>
  );
};
